import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'black' | 'charcoal';
}
export function Section({
  children,
  className = '',
  id,
  background = 'black'
}: SectionProps) {
  const bgClass = background === 'black' ? 'bg-luxury-black' : 'bg-luxury-charcoal';
  return <section id={id} className={`py-24 md:py-32 px-6 ${bgClass} ${className}`} data-id="element-191">
      <div className="max-w-6xl mx-auto" data-id="element-192">{children}</div>
    </section>;
}